import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { LogService } from '../../../../../../services/log-service';
import ModalPortal from '../../../../../../components/modal-portal';
import { SSMarketplaceSettings } from '../../../../../../connection-components/marketplace-settings';

import style from './style.module.less';

const defaultOnError = (error) => LogService.logError(new Error('Marketplace settings error', { cause: error }));

const MarketplaceSettingsModal = ({ onClose, onSave, onError = defaultOnError, storeGuid, marketplaceApiCode }) => (
  <ModalPortal containerId='marketplace-settings-modal' onClose={onClose}>
    <Modal className={classnames(style['marketplace-settings-modal'])}>
      <ModalHeader closeModal={onClose}>
        <FormattedMessage defaultMessage='Modify Marketplace Settings' description='Modify Marketplace Settings modal title' id='HJ6lAq' />
      </ModalHeader>
      <ModalBody className={style['modal-body']}>
        <SSMarketplaceSettings
          marketplaceApiCode={marketplaceApiCode}
          onCancel={onClose}
          onError={onError}
          onSave={onSave}
          storeGuid={storeGuid}
        />
      </ModalBody>
    </Modal>
  </ModalPortal>
);

MarketplaceSettingsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onError: PropTypes.func,
  onSave: PropTypes.func.isRequired,
  storeGuid: PropTypes.string.isRequired,
  marketplaceApiCode: PropTypes.number.isRequired,
};

export default MarketplaceSettingsModal;
